
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-dark-card border-t border-dark-lighter shadow-2xl"
        >
          <div className="w-full px-4 py-4 md:py-5">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 max-w-7xl mx-auto">
              <div className="flex items-start space-x-3 flex-1">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-orange/10 rounded-lg flex-shrink-0">
                  <i className="ri-cookie-line text-xl text-primary-orange"></i>
                </div>
                <div>
                  <p className="text-sm text-light-text leading-relaxed">
                    Utilizamos cookies para mejorar tu experiencia en nuestro sitio web. Al continuar navegando, aceptas nuestra{' '}
                    <a href="/politica-cookies" className="text-primary-orange hover:underline">
                      política de cookies
                    </a>.
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-3 flex-shrink-0">
                <button
                  onClick={handleReject}
                  className="px-5 py-2.5 text-sm font-medium text-light-muted hover:text-light-text border border-dark-lighter rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                >
                  Rechazar
                </button>
                <button
                  onClick={handleAccept}
                  className="px-5 py-2.5 text-sm font-medium bg-primary-orange text-white rounded-lg hover:shadow-glow-orange transition-all whitespace-nowrap cursor-pointer"
                >
                  Aceptar cookies
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
